/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 5/19/26
 * Time: 4:31 PM
 * Email: mdmehedihasanroni28@gmail.com
 */
import axios from "axios";
import * as URL from "../../helpers/Constants";
import {getPharmacyId} from "../../helpers/Utils";

export default class OtpService {

    static sendOtp(data) {
        return axios.post(`${URL.SEND_OTP_URL}/${getPharmacyId()}`, data, OtpService.getAuthHeader());
    }

    static resendOtp(data) {
        return axios.post(`${URL.RESEND_OTP_URL}/${getPharmacyId()}`, data, OtpService.getAuthHeader());
    }

    static verifyOtp(data) {
        return axios.post(`${URL.VERIFY_OTP_URL}/${getPharmacyId()}`, data, OtpService.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {headers: {Authorization: `Bearer ${accessToken}`}};
    }

}